import { FieldType } from '../types/field-type';
import { Field } from '../data/field';
import { ConditionalType } from '../types/conditional-type';

export class BodyField {
  id: string | undefined;
  name: string | undefined;
  description: string | undefined;
  tag: string | null;
  required: boolean | undefined;
  conditionalType: ConditionalType | null | undefined;
  conditionalTerms: string[] | undefined;
  presented: boolean | undefined;
  type: FieldType | undefined;
  definition: string | undefined;
  columnWidth: number | undefined;
  order: number | undefined;

  constructor(field: Field) {
    this.id = field.id;
    this.name = field.name?.trim();
    this.description = field.description?.trim();
    this.tag = field.tag?.trim() ?? null;
    this.required = field.required;
    this.conditionalType = field.conditionalType;
    this.conditionalTerms = field.conditionalTerms;
    this.presented = field.presented;
    this.type = field.type;
    this.definition = BodyField.fieldCustomParameterToDefinition(field);
    this.columnWidth = field.columnWidth;
    this.order = field.order;
  }

  private static fieldCustomParameterToDefinition(field: Field): string {
    if (field.fieldCustomParameter) {
      for (const [key, value] of Object.entries(field.fieldCustomParameter)) {
        if (Array.isArray(value)) {
          field.fieldCustomParameter[key] = value.filter((s: string) => s.trim());
        }
        if (!value || (typeof value === 'string' && !value.trim())) {
          field.fieldCustomParameter[key] = undefined;
        }
      }
      return JSON.stringify(field.fieldCustomParameter);
    } else {
      return '{}';
    }
  }
}
